// extracted by mini-css-extract-plugin
module.exports = {"CenterScreenSpinnerContainer":"App_CenterScreenSpinnerContainer__2qZEi"};